<template>
  <div class="spinner-border spinner-border-sm text-primary ms-3" role="status">
    <span class="sr-only d-none">Loading...</span>
  </div>
</template>

<script>
export default {
  name: 'SmallSpinner'
}
</script>
